<template>
  <div class="outer-div">
      <div>
        <v-form
          ref="form"
          v-model="valid"
        >
            <v-text-field
              v-model="mobile"
              label="Mobile Number*"
              light
              required
              outlined
            />

          <p
            class="text-center grey--text"
          >
            OR
          </p>

          <v-text-field
            v-if="getCurrentSelectedUserType === 'staff'"
            v-model="email"
            label="Employee Id*"
            light
            required
            outlined
          />

          <v-text-field
            v-else
            v-model="email"
            label="Email Address*"
            light
            required
            outlined
          />
        </v-form>
      </div>
      <div class="btn-container">
        <v-btn color="orange darken-3" x-large block dark
          class="rounded-xl"
          :disabled="isSubmitDisabled"
          @click.prevent="onFormSubmit()"
          >
          Checkout
        </v-btn>
      </div>
  </div>
</template>

<script>
import axios from '@/app-axios'
import moment from 'moment'
import constants from '@/constants'

export default {
  name: 'Checkout',

  data: () => ({
    valid: false,
    email: '',
    mobile: '',
    employeeId: '',
    errorResponse: ''
  }),

  computed: {
    getCurrentSelectedUserType () {
      return this.$store.getters['decision/getCustomerType']
    },
    hasEmptyFields () {
      return this.email.trim() === '' &&
         this.mobile.trim() === '' &&
         this.employeeId.trim() === ''
    },
    isSubmitDisabled () {
      return this.hasEmptyFields
    }
  },

  methods: {
    onFormSubmit () {
      const config = {
        headers: {
          'x-organization-id': this.$store.getters['swiftuser/getOrganizationId'],
          'x-digi-board-id': this.$store.getters['swiftuser/getDigiBoardId']
        }
      }
      axios.get('api/swift-checkin/search/' + this.mobile, config).then(response => {
        if (response.status === 200) {
          this.$store.dispatch('swiftuser/onAddUser', response.data)
          config.headers['x-swift-user-id'] = response.data.id
          this.checkout(config)
        }
      })
    },

    checkout (config) {
      axios.post('api/swift-checkin/checkout', {
        check_out_time: moment.utc().format(),
        type: 'contractor', // this doesn't matter as BE is not considering this value.
        extra_details: {
          covid_check_completed: true
        }
      }, config).then(response => {
        this.$emit('stepSuccess')
      }).catch(error => {
        this.$store.dispatch('alert/onAlert', {
          message: error.response.data.message,
          type: constants.ALERT_TYPE_ERROR
        })
      })
    }
  }
}
</script>

<style lang="css" scoped>
.outer-div {
  margin-top: 10px;
  height: 100%;
}
</style>
